import { FC, MouseEvent } from "react";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator"
import GetAppIcon from '@material-ui/icons/GetApp';
import { IconButton } from "@material-ui/core";
import {
  PromoCodesTableCell,
  PromoCodesTableRow,
} from "./PromoCodes.style";
import { PromoCodeCollection, useGetPromoCodeCollectionCsvLazyQuery } from "../../generated/graphql";
import { convertDateStringToLocaleHandler } from "../shared/Utils/ConvertOperations/convertDateStringToLocaleHandler";

interface PromoCodeProps extends PromoCodeCollection {
  onEdit: (id: string) => void;
}

export const PromoCode: FC<PromoCodeProps> = ({ id, createdDate, expiredDate, name, description, recipient, onEdit }) => {
  const [getCSV, { loading }] = useGetPromoCodeCollectionCsvLazyQuery();

  const handleDownload = async (e: MouseEvent) => {
    e.stopPropagation();
    const { data } = await getCSV({ variables: { id }, fetchPolicy: "network-only" });
    const csv = data?.getPromoCodeCollectionCSV;
    if (!csv) return;

    const link = document.createElement("a");
    link.href = csv;
    link.download = `${name ?? id}.csv`;
    link.click();
  };

  return (
    <PromoCodesTableRow onClick={() => onEdit(id)} style={{ cursor: "pointer" }}>
      <PromoCodesTableCell><DragIndicatorIcon /></PromoCodesTableCell>
      <PromoCodesTableCell>{convertDateStringToLocaleHandler(createdDate)}</PromoCodesTableCell>
      <PromoCodesTableCell>{convertDateStringToLocaleHandler(expiredDate)}</PromoCodesTableCell>
      <PromoCodesTableCell>{name}</PromoCodesTableCell>
      <PromoCodesTableCell>{description}</PromoCodesTableCell>
      <PromoCodesTableCell>{recipient}</PromoCodesTableCell>
      <PromoCodesTableCell>
        <IconButton size="small" onClick={handleDownload} disabled={loading}>
          <GetAppIcon />
        </IconButton>
      </PromoCodesTableCell>
      <PromoCodesTableCell/>
    </PromoCodesTableRow>
  );
};